<template>
  <section :class="['theme-artPhoto', name]" @scroll="handleScroll" ref="container">
    <!-- banner -->
    <img class="banner" :src="allData.bannerImg" @load="bannerLoad" />
    <template v-for="(item, index) in allData.bannerImglist">
      <img class="banner" :key="index" :src="item" @load="bannerLoad" />
    </template>

    <!-- nav -->
    <component
      ref="navBar"
      :is="allData.navData.component"
      :css="allData.navCss"
      :navData="allData.navData"
      :actived="actived"
      :fixNavTop="fixNavTop"
      @farClick="handleNavFarClick"
      @sonClick="handleNavSonClick"
      @thirdClick="handleNavThirdClick"
    ></component>

    <!-- ctn -->
    <div class="content">
      <!-- 图片展示 -->
      <div class="img-list-wrap" @click="handleClick">
        <div class="img-con" ref="imgCon" v-for="(img, index) in allData.pictures" :key="index">
          <template v-if="img.src">
            <img
              :ref="img.ref"
              :src="img.src"
              :data-id="img.id"
              :data-type="img.type"
              :data-fun="img.fun"
            />
          </template>
          <template v-else>
            <img
              :ref="index == 0 ? img.ref : ''"
              v-for="(son, index) in img.son"
              :key="index"
              :src="son"
              :data-id="img.id"
              :data-type="img.type"
              :data-fun="img.fun"
            />
          </template>
        </div>
        <!-- <img class="img-con" :src="authorityImg" /> -->
      </div>
    </div>

    <!-- float box -->
    <img
      v-if="allData.floatImg"
      class="float-box"
      :src="allData.floatImg"
      @click="handleBoxClick"
    />
  </section>
</template>

<script>
import { changeTitle } from "@/util/index.js";
import minirouterMethod from "@/mixins/minirouterMethod.js";
import config from "./utils/config/index";

export default {
  name: "themeNoralPage",
  mixins: [minirouterMethod],
  data() {
    return {
      actived: {},
      fixNavTop: false,
      name: "",
      navToTop: 0,
      navHeight: 0,
      bannerLoadNum: 0,
      timer: null,
      reSizeTimer: null,
      flag: false
    };
  },
  created() {
    const { name } = this.$route.params;
    this.name = name;
    config[this.name].onlonadFun && config[this.name].onlonadFun(this);
    let navData = config[this.name].navData;
    const defaultFar = navData.top[0].key;
    const defaultSon = navData.bottom ? navData.bottom[defaultFar][0].key : "";
    const defaultThird = navData.third ? navData.third[defaultFar + defaultSon][0].key : "";
    this.actived = {
      far: defaultFar,
      son: defaultSon,
      third: defaultThird
    };

    // 承接页浏览埋点
    this.$sensors.track("onPageView", {
      page_souce: document.referrer,
      page_name: `产品承接页-${config[this.name].title}`,
      page_id: 0,
      page_url: window.location.href,
      page_content: ""
    });

    changeTitle(config[this.name].title);
  },
  mounted() {
    this.handleWindowResize();
  },
  computed: {
    allData() {
      if (!config[this.name]?.bannerImglist) config[this.name].bannerImglist = [];
      return config[this.name];
    },
    routerName() {
      return this.$route.params.name;
    }
  },
  watch: {
    routerName() {
      this.name = this.routerName;
    },
    "actived.far"() {
      this.allData.farChangeFun && this.allData.farChangeFun(this.actived, this.allData);
    },
    "actived.son"() {
      this.allData.sonChangeFun && this.allData.sonChangeFun(this.actived, this.allData);
    }
  },
  methods: {
    async bannerLoad(e) {
      this.bannerLoadNum += 1;
      let bannerImglistLen = this.allData?.bannerImglist?.length || 0;
      if (this.bannerLoadNum >= bannerImglistLen + 1) {
        await this.$nextTick();
        this.timer = setInterval(() => {
          let navRef = this.$refs?.navBar?.$refs.navBtnCon;
          if (navRef?.offsetTop > 10) {
            this.navToTop = navRef?.offsetTop;
            this.navHeight = navRef.offsetHeight;
            clearInterval(this.timer);
          }
        }, 500);
      }
    },

    // 点击切换navfar
    handleNavFarClick(data) {
      let key = data.name;
      if (this.actived.far === key) return;

      this.actived.far = key;

      let name =
        key + (this.allData.topDiff.firstSon || "") + (this.allData.topDiff.firstThird || "");

      let diff = this.allData.topDiff[name] || 0;

      this.$nextTick(() => {
        this.$refs["container"].scrollTop = this.$refs[name][0].offsetTop - this.navHeight + diff;
      });
    },

    // 点击切换navson
    handleNavSonClick(data) {
      let key = data.name;

      if (this.actived.son === key) return;

      this.actived.son = key;

      let name = this.actived.far + key + (this.allData.topDiff.firstThird || "");

      let diff = this.allData.topDiff[name] || 0;

      this.$nextTick(() => {
        this.$refs["container"].scrollTop = this.$refs[name][0].offsetTop - this.navHeight + diff;
      });
    },

    // 点击切换navthird
    handleNavThirdClick(data) {
      let key = data.name;

      if (this.actived.third === key) return;

      this.actived.third = key;

      let name = this.actived.far + this.actived.son + key;

      let diff = this.allData.topDiff[name] || 0;

      this.$nextTick(() => {
        this.$refs["container"].scrollTop = this.$refs[name][0].offsetTop - this.navHeight + diff;
      });
    },

    handleScroll(e) {
      let scrolledDistance = e.target.scrollTop + window.innerHeight;

      this.fixNavTop = e.target.scrollTop > this.navToTop;

      let imgCon = this.$refs.imgCon || [];
      if (imgCon.length === 0) {
        return;
      }

      let pictures = this.allData.pictures;

      if (scrolledDistance < imgCon[0].offsetTop) {
        // this.actived = {
        //   far: 'top1',
        //   son: '_i1'
        // }
        const far = this.allData.navData.top[0].key;
        const son = this.allData.navData.bottom ? this.allData.navData.bottom[far][0].key : "";
        const third = this.allData.navData.third
          ? this.allData.navData.third[far + son][0].key
          : "";
        this.actived = {
          far,
          son,
          third
        };
        return;
      }

      for (let i = 0; i < imgCon.length - 1; i++) {
        if (!pictures[i].farName) continue;
        if (
          scrolledDistance > imgCon[i].offsetTop + 400 &&
          scrolledDistance < imgCon[i + 1].offsetTop + 400
        ) {
          this.actived = {
            far: pictures[i].farName,
            son: pictures[i].sonName || "",
            third: pictures[i].thirdName || ""
          };
        }
      }
      if (scrolledDistance > imgCon[imgCon.length - 1].offsetTop + 400) {
        if (!pictures[imgCon.length - 1].farName) return false;
        this.actived = {
          far: pictures[imgCon.length - 1].farName,
          son: pictures[imgCon.length - 1].sonName || "",
          third: pictures[imgCon.length - 1].thirdName || ""
        };
      }
      this.allData.onScroll && this.allData.onScroll(this.actived,this)
    },

    // 监听点击事件并跳转到对应产品
    handleClick(e) {
      const prodId = e.target.dataset.id;
      const type = e.target.dataset.type;
      const fun = e.target.dataset.fun;
      if (fun) {
        return this[fun] && this[fun]();
      }
      if (prodId) {
        if (type === "kids") {
          // 承接页点击埋点
          this.$sensors.track("onPage_bannerClick", {
            banner_area_type: "产品承接页",
            banner_area_name: "产品承接页",
            product_id: prodId,
            banner_title: "",
            brand: type
          });
          if (window.__wxjs_environment === "miniprogram" || window.my) {
            window.location.href = `https://m.himokids.com/?type=miniapp&v2=#/product/${prodId}`;
          } else {
            window.location.href = `https://m.himokids.com/?v2=#/product/${prodId}`;
          }
        } else {
          this.miniRouterLink(type, prodId);
        }
      }
    },

    handleWindowResize() {
      let self = this;

      // 兼容window微信内置浏览器已进入就会触发window.onresize
      let isWindowsWeixin = window.navigator.userAgent.toLowerCase().includes("windowswechat");
      if (isWindowsWeixin) {
        // 避免微信
        setTimeout(() => {
          self.flag = true;
        }, 1000);
      }
      // 兼容window微信内置浏览器已进入就会触发window.onresize

      window.addEventListener(
        "resize",
        function() {
          if (isWindowsWeixin && !self.flag) return;
          self.reSizeTimer && clearTimeout(self.reSizeTimer);
          self.reSizeTimer = setTimeout(() => {
            self.timer && clearInterval(self.timer);
            window.location.reload();
          }, 300);
        },
        false
      );
    },

    handleBoxClick() {
      this.floatBoxClick && this.floatBoxClick();
    }
  }
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
